import type { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import Spinner from '@/components/Spinner/Spinner';

import useIsAdmin from '../hooks/useIsAdmin';

export interface AdminRouteProps {
  children: ReactNode;
}

/** Client-side convenience only — Firestore rules are what actually protect the data. */
export default function AdminRoute({ children }: AdminRouteProps): ReactElement {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center py-16">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
